// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"188":"ad6c2ffb","856":"18afa20f"}[chunkId] + ".js";
};